<template>
  <div class="container-fluid">
    <div class="row align-items-center">
      <div class="col-md-3 col-xl-6">
        <div>
          <!-- <h4 class="mb-1 mt-0" v-if="type == 'all'" >{{$t('application.all')}}</h4>
          <h4 class="mb-1 mt-0" v-else-if="type == 'active'">Active</h4>
          <h4 class="mb-1 mt-0" v-else>Inactive</h4> -->

          <!-- <button class="btn2 btn2-primary btn2-md mr-1 mb-3 mb-sm-0" @click="openCreateModal" v-if="role_modules.some(item => item.value == 'job.create')">
            <i class="uil-database mr-1"></i> {{ $t('job.action.create_record') }}
          </button> -->
          <!-- <button class="btn btn-warning mr-1 mb-3 mb-sm-0" @click="syncJobData">
            <i class="uil-sync mr-1"></i> {{$t('company.action.sync')}}
          </button> -->


          <!-- <Button 
            label="Advance Search" 
            class="btn2 btn2-primary btn2-md mr-1 mt-1" 
            icon="uil-search mr-1"
            @click="showHrflowDialog" v-if="role_modules.some(item => item.value == 'job.advance_search')"
          /> -->
          <!-- <button style="background: #01c0da;" class="btn mr-1 mb-3 mb-sm-0 p-1" @click="showHrflowDialog">
            <img src="https://hrflow-ai.imgix.net/logo.svg" width="120" height="30">
          </button> -->
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-xl-12">
        <DataTable 
          ref="list" 
          :type.sync="type"
          :hasFilter="true"
        >
        <template v-slot:custom-filter>
          <div class="row justify-content-end">
            <div class="col">
              <div class="btn-group ml-1" ref="filterButton">
                <button type="button" class="btn btn-white-primary" @click="toggleFilter" value="all">{{$t('application.all')}}</button>
                <button type="button" class="btn btn-white-primary" @click="toggleFilter" value="active">
                  Active
                </button>
                <button type="button" class="btn btn-white-primary" @click="toggleFilter" value="inactive">
                  Inactive
                </button>
              </div>
            </div>
            
          </div>
        </template>
        </DataTable>
      </div>
    </div>
    <!-- <ScrapeModal ref="scrapeModal" type="company"/> -->
    <OffCanvas
      centered
      ref="createModal"
      title="Create Job"
      size="xl"
      yesText="Submit"
      noText="Cancel"
      :buttonDisable="created"
      :component="computedCreateComponent"
      @onYes="onSubmit"
      @onPreview="onPreview"
    />
    <OffCanvas
      centered
      ref="scrapeModal"
      :titleHtml="'<i class=\'uil-database mr-1\'></i> Data Scraping'"
      size="lg"
      yesText="Scrape"
      noText="Cancel"
      :component="computedScrapeComponent"
      :buttonDisable="scraped"
      @onYes="onScrapeData"
    />
    <OffCanvas
      centered
      ref="hrflowModal"
      titleHtml="Search Job"
      size="lg"
      yesText="Search"
      noText="Cancel"
      :component="computedHrflowFieldsComponent"
      @onYes="onSearchField"
    />
    <Dialog
      centered
      ref="hrflowModalViewTable"
      titleHtml="Job(s)"
      size="lg"
      :component="computedHrFlowViewTableComponent"
      :parameters="{ data: hrflowData }"
      @onClick="onClickActions"
    />
    <Dialog
      centered
      ref="hrflowModalView"
      titleHtml="View Detail(s)"
      bodyClass="modalBodyContainer px-3"
      size="lg"
      :component="computedHrFlowViewComponent"
      :parameters="{ job: hrflowSelected }"
    />
    <OffCanvas
      centered
      title="View Job"
      ref="previewJob"
      bodyClass="modalBodyContainer px-4"
      size="xl"
      :component="computedViewJobComponent"
      :parameters="{ previewData, submitted, hasNoSetting: true }"
    />
    <!-- <CreateModal ref="createModal" @openFormBar="openFormBar" /> -->
  </div>
</template>

<script>
// import ScrapeModal from '@components/modals/job/scrapingModal'
// import CreateModal from '@pages/job/createModal'
import DataTable from '@common/datatable2'
import Dialog from '@components/dialogs'
import OffCanvas from '@components/offcanvas'
import CreateComponent from './components/dialogs/create.vue'
import ScrapeComponent from './components/dialogs/scrape.vue'
import HrflowComponent from './components/dialogs/hrflowFieldsSearch.vue'
import HrFlowViewTableComponent from './components/dialogs/viewHrflowTable.vue'
import HrFlowViewComponent from './components/dialogs/hrflowView'
import error from '@utils/error'

const _types = {
  all:0,
  active:1,
  inactive:2,
}
export default {
  components: { 
    // CreateModal,
    // ScrapeModal,
    DataTable, 
    Dialog,
    OffCanvas,
  },
  computed: {
    computedCreateComponent() {
      return CreateComponent;
    },
    computedHrflowFieldsComponent() {
      return HrflowComponent;
    },
    computedScrapeComponent() {
      return ScrapeComponent;
    },
    computedHrFlowViewTableComponent() {
      return HrFlowViewTableComponent;
    },
    computedHrFlowViewComponent() {
      return HrFlowViewComponent;
    },
    computedViewJobComponent() {
      return () => import('./components/dialogs/view.vue')
    }
  },
  data() {
    return {
      type: 'active',
      isFormModalOpen: false,
      created: false,
      scraped: false,
      submitted: false,
      hrflowData: {},
      hrflowSelected: {},
      previewData: {}
    }
  },
  methods: {
    onClickActions(val) {
      this.hrflowSelected = val
      this.$refs.hrflowModalView.show();
    },
    showHrflowDialog() {
      this.$refs.hrflowModal.show()
    },
    onSearchField(val) {
      let model = val && val.model && Object.entries(val.model).length ? val.model : {};
      this.$refs.list.params = { ...model }
      this.$refs.list.fetchData(false, 'active', true, true)
      this.$refs.hrflowModal.hide();
    },
    onScrapeData(val) {
      
      this.scraped = true;
      let model = val && val.model && Object.entries(val.model).length ? val.model : val

      setTimeout(() => this.$refs.scrapeModal.hide(), 2000);
      model.server_url = process.env.VUE_APP_SERVER_URL
      return this.$store.dispatch('job/scrapedata', { ...model })
      .then(res => {
        if(res && res.data && res.data.success){
          // this.$bvToast.toast('Successfully scraped!', {
          //   title: 'Notification',
          //   variant: 'success',
          //   autoHideDelay:5000
          // })
          setTimeout(() => {
            this.scraped = false;
          }, 1500)
        }
        else if (res && res.data && typeof res.data.success == 'boolean' && !res.data.success) {
          setTimeout(() => {
            this.scraped = false;
          }, 1500)
          let message = res.data.msg ? res.data.msg : 'Scraping was unsuccessful!'
          return error.errorHandler({ message }, this.$bvToast)
        }
      })
      .catch(err => {
        this.scraped = false
        return error.errorHandler(err, this.$bvToast)
      })
    },
    onSubmit(val) {
      this.created = true;
      let model = val && val.model && Object.entries(val.model).length ? val.model : val
      
      val.validateForm && val.validateForm();
      if (val.$v.$error) {
        this.created = false;
        return error.errorHandler({ message: "Required field(s) must not be empty" }, this.$bvToast)
      }

      model.city = model.city.text

      return this.$store.dispatch('job/create', { ...model })
      .then(res => {
        if (res && res.data) {
          let { data } = res

          this.$refs.createModal.hide();
          this.$refs.list.fetchData();
          this.$bvToast.toast(`${data.job.title} successfully added!`, {
            title: "Notification",
            variant: "success" 
          });

          setTimeout(() => {
            this.created = false;
          }, 1500)
        }
      })
      .catch(err => {
        this.created = false;
        return error.errorHandler(err, this.$bvToast)
      })
    },
    toggleFilter(e) {
      let filterButton = this.$refs['filterButton'],
        children = filterButton.children
      this.type = e.target.value
      for(var key in children){
        if(typeof children[key] == 'object'){
          children[key].classList.add('btn-white-primary')
          children[key].classList.remove('btn-primary')
        }
      }

      if(e.target){
        e.target.classList.add('btn-primary')
        e.target.classList.remove('btn-white-primary')
      }

      if(this.$refs['list'])
        this.$refs['list'].fetchData(false, e.target ? e.target.value : 'active', false)
    },
    syncJobData(){
      this.$refs.list.syncJobs()
    },
    scrapeData(){
      this.$refs.scrapeModal.show()
    },
    openCreateModal() {
      this.$refs.createModal.show()
      // this.$router.push({path: '/job/create'})
    },
    onPreview(previewData) {
      this.previewData = previewData
      this.$refs.previewJob.show()
    }
  },
  mounted(){
    this.toggleFilter({
      target:this.$refs['filterButton'].children[_types[this.$route.query.type || 'active']]
    })
  }
}
</script>

<style lang="scss">
  .modalBodyContainer {
    background: #e8eaee;
    overflow: auto;
    max-height: 80vh!important;
    height: 100%;
  }
</style>